<template>
<div class="mb-3 border-bottom">
    <span>{{ question.question }}</span>

    <form-question-check-box
        v-if="isQuestionType(['checkbox', 'checkbox_other'])"
        :question="question"
        :request_form="request_form"
        :settings="question_settings_computed"
        @update-value="updateValue"
    />

    <form-question-check-box
        v-else-if="isQuestionType(['dropdown', 'dropdown_other'])"
        :question="question"
        :request_form="request_form"
        :settings="question_settings_computed"
        is_radio
        @update-value="updateValue"
    />

    <form-question-date-time
        v-else-if="isQuestionType(['date'])"
        :question="question"
        :request_form="request_form"
        :settings="question_settings_computed"
        @update-value="updateValue"
    />

    <form-question-free-text
        v-else-if="isQuestionType(['free_text'])"
        :question="question"
        :request_form="request_form"
        :settings="question_settings_computed"
        @update-value="updateValue"
    />

    <div
        v-if="
            question_settings_computed.provide_image ||
            question_settings_computed.provide_comment
        "
        class="row"
    >
        <div
            v-if="question_settings_computed.provide_image"
            class="col py-2"
        >
            <form-question-image
                :required="!question_settings_computed.providing_image_optional"
                :question="question"
                :request_form="request_form"
                @update-value="updateValue"
            />
        </div>

        <div
            v-if="question_settings_computed.provide_comment"
            class="col py-2"
        >
            <form-question-comment
                :required="!question_settings_computed.providing_comment_optional"
                :question="question"
                :request_form="request_form"
                @update-value="updateValue"
            />
        </div>
    </div>
</div>
</template>

<script>
import { uniqueId } from 'lodash';
import FormQuestionCheckBox from '../questions/FormQuestionCheckBox';
import FormQuestionComment from '../questions/FormQuestionComment.vue';
import FormQuestionDateTime from '../questions/FormQuestionDateTime';
import FormQuestionFreeText from '../questions/FormQuestionFreeText';
import FormQuestionImage from '../questions/FormQuestionImage.vue';

export default {
    name: 'FormSubmittableQuestions',
    components: {
        FormQuestionCheckBox,
        FormQuestionComment,
        FormQuestionDateTime,
        FormQuestionFreeText,
        FormQuestionImage,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
        request_form: Object,
    },
    created() {
        this.question.local_id = this.question.id ?? uniqueId();
    },
    computed: {
        question_settings_computed() {
            return this.question.settings ?? {};
        },
    },
    methods: {
        isQuestionType(types) {
            return types.includes(this.question.type);
        },
        updateValue(id, value) {
            this.$emit('update-value', id, value);
        },
    },
};
</script>
